"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchById = exports.fetchByApplication = exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const planService_1 = require("./service/planService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)("plans/fetch", (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const planService = new planService_1.PlanService(Env_1.APIPATHENV);
        const response = yield planService.fetchPlanList(fetchPayload);
        return response;
    }
    catch (err) {
        throw new Error("Failed to fetch");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)("plans/create", (createPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const planService = new planService_1.PlanService(Env_1.APIPATHENV);
        const response = yield planService.createPlan(createPayload);
        return response;
    }
    catch (err) {
        throw new Error(err.response.data.message);
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)("plans/update", (createPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const planService = new planService_1.PlanService(Env_1.APIPATHENV);
        const response = yield planService.updatePlan(createPayload);
        return response;
    }
    catch (err) {
        throw new Error(err.response.data.message);
    }
}));
exports.fetchByApplication = (0, toolkit_1.createAsyncThunk)("plans/fetchByApplication", (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const planService = new planService_1.PlanService(Env_1.APIPATHENV);
        const response = yield planService.fetchPlanByApplication(fetchPayload);
        return response;
    }
    catch (err) {
        throw new Error("Failed to fetch");
    }
}));
exports.fetchById = (0, toolkit_1.createAsyncThunk)("plans/fetchById", (planId, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const planService = new planService_1.PlanService(Env_1.APIPATHENV);
        const response = yield planService.fetchPlanById(planId);
        return response;
    }
    catch (err) {
        throw new Error("Failed to fetch");
    }
}));
